<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'支付详情'"></div>
    <div class="query-wrapper">
      <div class="query-page" id="query-page">
        <div :class="'icon icon-' + icon_state"></div>
        <h2>{{current_title}}</h2>
        <h3>订单号：<span>{{ order }}</span></h3>
        <p class="wait-info" v-html="wait_info"></p>
        <a class="btn" @click="returnActivity()" href="javascript:;">确定</a>
      </div>
    </div>
  </div>

</template>
<script>
import { analysisParams, getTimeStamp } from '@/utils/utils';
import { checkOrderAPI } from '../api';

export default {
  components: {},
  data () {
    return {
      wait: 15,
      icon_state: '',
      order: '',
      role_id: '',
      token: '',
      game_id: '',
      server_id: '',
      os: '',
      web_bonus_id: '',
      wait_info: '支付查询中<br/>请稍等',
      current_title: '等待支付结果完成中'
    };
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.queryHash();
    });
  },
  computed: {},
  methods: {
    isReloadWindow (event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance && window.performance.navigation && window.performance.navigation.type === 2))
      );
    },
    // 查询信息
    queryHash() {
      const params = analysisParams(window.location.href);
      this.order = params.out_trade_no;
      console.log(params)
      if(params.role_id !== undefined)      this.role_id = params.role_id;
      if(params.token !== undefined)        this.token = params.token;
      if(params.game_id !== undefined)      this.game_id = params.game_id;
      if(params.server_id !== undefined)    this.server_id = params.server_id;
      if(params.os !== undefined)           this.os = params.os;
      if(params.web_bonus_id !== undefined) this.web_bonus_id = params.web_bonus_id;
      this.orderLoop();
    },
    // 返回活动
    returnActivity() {
      const host = window.location.host;
      window.location.href = `//`+  host + `/snail/four-anniversary/enter` + `${getTimeStamp()}` +'?' + '&role_id=' + this.role_id + '&token=' + this.token + '&game_id=' + this.game_id  + '&server_id=' + this.server_id + '&os=' + this.os + '&web_bonus_id=' + this.web_bonus_id;
      // +'?' + '&role_id=' + this.role_id + '&token=' + this.token + '&game_id=' + this.game_id  + '&server_id=' + this.server_id + '&os=' + this.os + '&web_bonus_id=' + this.web_bonus_id;
    },
    // 订单轮询
    orderLoop() {
      var _this = this;
      if (_this.wait > 0) {                
        _this.wxPayment();
        _this.wait--;
        _this.wait_info = "支付查询中<br/>请稍等 (" + _this.wait + 's)'
        setTimeout(function() {
          _this.orderLoop();
        }, 1500)
      }
    },
    // 订单查询
    wxPayment() {
      checkOrderAPI({trade_no: this.order})
        .then((response) => {
          this.current_title = response.message;
          if (Number(response.code) == 200) {
            this.wait = 0;
            this.icon_state = true;
            this.wait_info = '';
            return;
          }
          if (Number(response.code) != 200) {
            if(this.wait == 0) {
              this.current_title = '支付失败';
              this.icon_state = false;
              this.wait_info = '';
              return;
            }
          }
      });
    },
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/sixAnniversary/query/index.vue